export function isMatchUrl(currentUrl: string, comparisonUrl: string): boolean {
  return !!currentUrl.match(comparisonUrl)
}

export function getRouteName(routeName?: string | null) {
  return routeName?.replace('___en', '').replace('___ja', '')
}
